import { createAction, props } from '@ngrx/store';
import { ProjectData } from 'src/app/shared/types/projects';

const projectIsCreated = 'PROJECT_IS_CREATED';
const removeRecentProject = 'REMOVE_RECENT_PROJECT';
export const projectIsCreatedAction = createAction(
  projectIsCreated,
  props<{ newProject: ProjectData }>()
);

export const removeRecentProjectAction = createAction(removeRecentProject);
